import React from "react";
import { Table } from "@emisgroup/ui-table";
import { TableProps } from "./TableContainer/Types";
import { TableContainer } from "./TableContainer/TableContainer.logic";

interface CustomTableProps {
  /**
   * Table data to display
   */
  tableData: TableProps;
  /**
   * Empty table message text
   */
  emptyStateText: string;
  /**
   * Custom css class for the current table component
   */
  className?: string;
  /**
   * On Table row selection
   * @param e event object for the particular row selection
   */
  onRowSelected?: (e: React.MouseEvent<any>) => void;
  /**
   * Unique id for the particular table component
   */
  id: string;
}


/**
 * Responsible for rendering the table component
 * @returns table row  elements
 */
export const UITable: React.FC<CustomTableProps> = (props: CustomTableProps) => {

  const { tableData, emptyStateText, className, id, onRowSelected } = props;

  return (
    <Table className={className} id={id}>
      <TableContainer
        table={tableData}
        emptyStateText={emptyStateText}
        onRowSelected={onRowSelected}
      />
    </Table>
  );
};
